// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"mWXlxDHhjK6UFgc_l4Rx"};